import { render, staticRenderFns } from "./VehicleDisplayView.vue?vue&type=template&id=27feb721"
import script from "./VehicleDisplayView.vue?vue&type=script&lang=js"
export * from "./VehicleDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports